import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export const usePreviousRouteIsSearch = () => {
  const pathname = usePathname();

  const ref = useRef<string | null>(null);

  useEffect(() => {
    ref.current = pathname;
  }, [pathname]);

  return (
    ref.current?.startsWith("/for-sale") &&
    !ref.current?.startsWith("/for-sale/details/")
  );
};
